export default [
  {
    path: "",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/views/home/activity/index.vue"),
    meta: {
      title: "活动列表"
    }
  },
  {
    path: "/activity-detail",
    name: "activity-detail",
    component: () => import("@/views/home/activity/detail.vue"),
    meta: {
      title: "活动详情"
    }
  }
];
